import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Users from "../Modules/Users";
import Settings from "../Modules/Settings";
import Dashboard from "../Modules/Dashboard";
import PrivateRoutes from "./PrivateRoutes";
import { SuperAdminRoute, SelfOrSuperAdminRoute } from "./guards";
import Login from "../PublicModels/Login";
import ProfilePage from "../Modules/Admin/ProfilePage";
import Register from "../PublicModels/Register";
import PublicRoutes from "./PublicRoutes";
import Page404 from "../Common/Page404";
import Addadmin from "../Modules/Admin/Addadmin";
import UpdateAdmin from "../Modules/Admin/UpdateAdmin";
import AddUser from "../Modules/User/AddUser";
import UpdateUser from "../Modules/User/UpdateUser";
import AddTermsCondition from "../Modules/TermsCondition/AddTermsCondition";
import UpdateTermsCondition from "../Modules/TermsCondition/UpdateTermsCondition";
import TermsConditionList from "../Modules/TermsCondition/TermsConditionList";
import UserList from "../Modules/User/UserList";
import AdminList from "../Modules/Admin/AdminList";
import RoleHistoryList from "../Modules/Admin/RoleHistoryList";
import BookingList from "../Modules/Booking/BookingList";
import SavedAddressList from "../Modules/User/SavedAddressList";
import NotificationList from "../Modules/Notification/NotificationList";
import RatingList from "../Modules/Rating/RatingList";
import AddWishList from "../Modules/WishList/AddWishList";
import PartnerList from "../Modules/DriverManagement/PartnerList";
import AddPartner from "../Modules/DriverManagement/AddPartner";
import UpdatePartner from "../Modules/DriverManagement/UpdatePartner";
import ContactusListing from "../Modules/Contactus/ContactusListing";
import SizeList from "../Modules/Catalouge/Size/SizeList";
import AddSize from "../Modules/Catalouge/Size/AddSize";
import UpdateSize from "../Modules/Catalouge/Size/UpdateSize";
import ColorList from "../Modules/Catalouge/Color/ColorList";
import AddColor from "../Modules/Catalouge/Color/AddColor";
import UpdateColor from "../Modules/Catalouge/Color/UpdateColor";
import ProductList from "../Modules/Catalouge/Product/ProductList";
import AddProduct from "../Modules/Catalouge/Product/AddProduct";
import UpdateProduct from "../Modules/Catalouge/Product/UpdateProduct";
import ProductBulkUpload from "../Modules/Catalouge/Product/ProductBulkUpload";
import ImportImagesPage from "../Modules/Catalouge/Product/ImageImport/ImportImagesPage";
import GeneralScreen from "../Modules/Catalouge/Product/form/GeneralScreen";
import AdvanceScreen from "../Modules/Catalouge/Product/form/AdvanceScreen";
import HistoryScreen from "../Modules/Catalouge/Product/form/HistoryScreen";
import OccassonList from "../Modules/Catalouge/occassion/OccassonList";
import AddOccassion from "../Modules/Catalouge/occassion/AddOccassion";
import UpdateOccassion from "../Modules/Catalouge/occassion/UpdateOccassion";
import BrandList from "../Modules/Catalouge/Brand/BrandList";
import BrandForm from "../Modules/Catalouge/Brand/BrandForm";
import Colors from "../Modules/DriverManagement/Colors";
import OffersList from "../Modules/offers/OffersList";
import AddOffers from "../Modules/offers/AddOffers";
import UpdateOffers from "../Modules/offers/UpdateOffers";
import CartList from "../Modules/Cart/CartList";
// import ViewPage from "../Modules/Cart/ViewPage";
import WishlistList from "../Modules/WishList/WishList";
import CustomerSearches from "../Modules/Searches/CustomerSearches";
import OrderView from "../Modules/Order/OrderView";
import DriverList from "../Modules/Driver/DriverList";
import AddDriver from "../Modules/Driver/AddDriver";
import UpdateDriver from "../Modules/Driver/UpdateDriver";
import OrderListPage from "../Modules/Order/OrderListPage";
import CreateWallet from "../Modules/Wallet/CreateWallet";
import WalletList from "../Modules/Wallet/WalletList";
import WalletValiditiesList from "../Modules/WalletValidities/WalletValiditiesList";
import CreateWalletValidities from "../Modules/WalletValidities/CreateWalletValidities";
import UpdateWalletValidities from "../Modules/WalletValidities/UpdateWalletValidities";
import BulkParentPage from "../Modules/BulkEdit/BulkParentPage";
import ContactDetails from "../Modules/Setting/ContactDetails.jsx";
import EmailEvents from "../Modules/Setting/EmailEvents";
import ContactListPage from "../Modules/Setting/ContactList.jsx";
import ContentPagesList from "../Modules/ContentPages/ContentPagesList";
import ContentPageForm from "../Modules/ContentPages/ContentPageForm";
import PushNotification from "../Modules/Setting/PushNotification.jsx";
import LoyaltyPointsPage from "../Modules/LoyaltyPoints/LoyaltyPointsPage";
import DynamicSectionsList from "../Modules/DynamicSections/DynamicSectionsList";
import HomepageArrange from "../Modules/DynamicSections/HomepageArrange";
import DynamicSectionForm from "../Modules/DynamicSections/DynamicSectionForm";
import TrustStrip from "../Modules/DynamicSections/TrustStrip";
import BannersList from "../Modules/Banners/BannersList";
import BannerForm from "../Modules/Banners/BannerForm";
import PromoPopupsList from "../Modules/PromoPopups/PromoPopupsList";
import PromoPopupForm from "../Modules/PromoPopups/PromoPopupForm";
import CatalogWorkbench from "../Modules/Catalog/CatalogWorkbench";





function AppRoutes() {
  return (
    <div className="app">
      <Routes>
        <Route
          path="/"
          element={
            <PublicRoutes>
              <Login />
            </PublicRoutes>
          }
        />
        <Route
          path="/register"
          element={
            <PublicRoutes>
              <Register />
            </PublicRoutes>
          }
        />
        <Route
          path="/dashboard"
          element={
            <PrivateRoutes>
              <Dashboard />
            </PrivateRoutes>
          }
        />
        <Route
          path="/users"
          element={
            <PrivateRoutes>
              <Users />
            </PrivateRoutes>
          }
        />
        <Route
          path="/settings"
          element={
            <PrivateRoutes>
              <Settings />
            </PrivateRoutes>
          }
        />
        <Route
          path="/contactdetails"
          element={
            <PrivateRoutes>
              <ContactDetails />
            </PrivateRoutes>
          }
        />
        <Route
          path="/emailevents"
          element={
            <PrivateRoutes>
              <EmailEvents />
            </PrivateRoutes>
          }
        />
        <Route
          path="/contactlist"
          element={
            <PrivateRoutes>
              <ContactListPage />
            </PrivateRoutes>
          }
        />
        {/* The old single-text FAQ and Terms screens edited tables nothing
            reads any more; their addresses now open the new editors. */}
        <Route path="/faq" element={<Navigate to="/content-pages/faq" replace />} />
        <Route
          path="/content-pages"
          element={
            <PrivateRoutes>
              <ContentPagesList />
            </PrivateRoutes>
          }
        />
        <Route
          path="/content-pages/:key"
          element={
            <PrivateRoutes>
              <ContentPageForm />
            </PrivateRoutes>
          }
        />
        <Route path="/termandcondition" element={<Navigate to="/content-pages/terms" replace />} />
        <Route
          path="/order/list"
          element={
            <PrivateRoutes>
              <OrderListPage />
            </PrivateRoutes>
          }
        />
        <Route
          path="/order/list/:tab"
          element={
            <PrivateRoutes>
              <OrderListPage />
            </PrivateRoutes>
          }
        />
        <Route path="/order/log" element={<Navigate to="/order/list/log" replace />} />
        <Route path="/order/timeout" element={<Navigate to="/order/list/timeout" replace />} />
        <Route
          path="/notification"
          element={
            <PrivateRoutes>
              <PushNotification />
            </PrivateRoutes>
          }
        />

        <Route
          path="/addwishlist"
          element={
            <PrivateRoutes>
              <AddWishList />
            </PrivateRoutes>
          }
        />
        <Route
          path="/catalog"
          element={
            <PrivateRoutes>
              <CatalogWorkbench />
            </PrivateRoutes>
          }
        />
        {/* Legacy catalog routes — consolidated into the /catalog workbench.
            Kept as redirects so old links/bookmarks don't 404. */}
        <Route path="/category" element={<Navigate to="/catalog" replace />} />
        <Route path="/subcategory" element={<Navigate to="/catalog" replace />} />
        <Route path="/category/add" element={<Navigate to="/catalog" replace />} />
        <Route path="/subcategory/add" element={<Navigate to="/catalog" replace />} />
        <Route
          path="/user/update/:id"
          element={
            <PrivateRoutes>
              <SavedAddressList />
            </PrivateRoutes>
          }
        />

        <Route
          path="/notification"
          element={
            <PrivateRoutes>
              <NotificationList />
            </PrivateRoutes>
          }
        />
        <Route
          path="/rating"
          element={
            <PrivateRoutes>
              <RatingList />
            </PrivateRoutes>
          }
        />
        <Route
          path="/wishlist"
          element={
            <PrivateRoutes>
              <WishlistList />
            </PrivateRoutes>
          }
        />
        <Route
          path="/searches"
          element={
            <PrivateRoutes>
              <CustomerSearches />
            </PrivateRoutes>
          }
        />
        <Route
          path="/contactus"
          element={
            <PrivateRoutes>
              <ContactusListing />
            </PrivateRoutes>
          }
        />

        <Route
          path="/wallet/add"
          element={
            <PrivateRoutes>
              <CreateWallet />
            </PrivateRoutes>
          }
        />

        <Route
          path="/wallet/list"
          element={
            <PrivateRoutes>
              <WalletList />
            </PrivateRoutes>
          }
        />

        <Route
          path="/wallet/validities/list"
          element={
            <PrivateRoutes>
              <WalletValiditiesList />
            </PrivateRoutes>
          }
        />

        <Route
          path="/wallet/validities/add"
          element={
            <PrivateRoutes>
              <CreateWalletValidities />
            </PrivateRoutes>
          }
        />

        <Route
          path="/wallet/validities/update/:id"
          element={
            <PrivateRoutes>
              <UpdateWalletValidities />
            </PrivateRoutes>
          }
        />

        <Route
          path="/loyalty-points"
          element={
            <PrivateRoutes>
              <LoyaltyPointsPage />
            </PrivateRoutes>
          }
        />

        <Route
          path="/booking"
          element={
            <PrivateRoutes>
              <BookingList />
            </PrivateRoutes>
          }
        />
        <Route path="/category/update/:id" element={<Navigate to="/catalog" replace />} />
        <Route path="/subcategory/update/:id" element={<Navigate to="/catalog" replace />} />

        <Route
          path="/admin"
          element={
            <SuperAdminRoute>
              <AdminList />
            </SuperAdminRoute>
          }
        />
        <Route
          path="/admin/history"
          element={
            <SuperAdminRoute>
              <RoleHistoryList />
            </SuperAdminRoute>
          }
        />
        <Route
          path="/admin/add"
          element={
            <SuperAdminRoute>
              <Addadmin />
            </SuperAdminRoute>
          }
        />
        <Route
          path="/admin/update/:id"
          element={
            <SelfOrSuperAdminRoute>
              <UpdateAdmin />
            </SelfOrSuperAdminRoute>
          }
        />
        <Route
          path="/admin/view/:id"
          element={
            <SuperAdminRoute>
              <UpdateAdmin readOnly />
            </SuperAdminRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <PrivateRoutes>
              <ProfilePage />
            </PrivateRoutes>
          }
        />

        <Route path="/order/placed" element={<Navigate to="/order/list/placed" replace />} />
        <Route path="/order/Confirmed" element={<Navigate to="/order/list/confirmed" replace />} />
        <Route path="/order/confirmed" element={<Navigate to="/order/list/confirmed" replace />} />
        <Route path="/order/processing" element={<Navigate to="/order/list/processing" replace />} />
        <Route path="/order/ready" element={<Navigate to="/order/list/ready" replace />} />
        <Route path="/order/delivered" element={<Navigate to="/order/list/delivered" replace />} />
        <Route path="/order/cancelled" element={<Navigate to="/order/list/cancelled" replace />} />
        <Route path="/order/returned" element={<Navigate to="/order/list/returned" replace />} />
        <Route path="/order/on-hold" element={<Navigate to="/order/list/on-hold" replace />} />

        <Route
          path="/orderview/:orderId"
          element={
            <PrivateRoutes>
              <OrderView />
            </PrivateRoutes>
          }
        />

         <Route
          path="/bulk/edit"
          element={
            <PrivateRoutes>
              <BulkParentPage />
            </PrivateRoutes>
          }
        />

        
    


        <Route
          path="/driverlist"
          element={
            <PrivateRoutes>
              <DriverList />
            </PrivateRoutes>
          }
        />

        <Route
          path="/driver/add"
          element={
            <PrivateRoutes>
              <AddDriver />
            </PrivateRoutes>
          }
        />

        <Route
          path="/user"
          element={
            <PrivateRoutes>
              <UserList />
            </PrivateRoutes>
          }
        />
        <Route
          path="/user/add"
          element={
            <PrivateRoutes>
              <AddUser />
            </PrivateRoutes>
          }
        />

        <Route
          path="/driver/update/:id"
          element={
            <PrivateRoutes>
              <UpdateDriver />
            </PrivateRoutes>
          }
        />

        <Route
          path="/user/update/:id"
          // path="/saved"

          element={
            <PrivateRoutes>
              <UpdateUser />
            </PrivateRoutes>
          }
        />

        <Route
          path="/termscondition"
          element={
            <PrivateRoutes>
              <TermsConditionList />
            </PrivateRoutes>
          }
        />
        <Route
          path="/termscondition/add"
          element={
            <PrivateRoutes>
              <AddTermsCondition />
            </PrivateRoutes>
          }
        />
        <Route
          path="/termscondition/update/:id"
          element={
            <PrivateRoutes>
              <UpdateTermsCondition />
            </PrivateRoutes>
          }
        />

        <Route
          path="/partner"
          element={
            <PrivateRoutes>
              <PartnerList />
            </PrivateRoutes>
          }
        />
        <Route
          path="/mycolor"
          element={
            <PrivateRoutes>
              <Colors />
            </PrivateRoutes>
          }
        />
        <Route
          path="/addpartner"
          element={
            <PrivateRoutes>
              <AddPartner />
            </PrivateRoutes>
          }
        />
        <Route
          path="/updatepartner/:id"
          element={
            <PrivateRoutes>
              <UpdatePartner />
            </PrivateRoutes>
          }
        />
        <Route
          path="/size"
          element={
            <PrivateRoutes>
              <SizeList />
            </PrivateRoutes>
          }
        />
        <Route
          path="/addsize"
          element={
            <PrivateRoutes>
              <AddSize />
            </PrivateRoutes>
          }
        />
        <Route
          path="/upadtesize/:id"
          element={
            <PrivateRoutes>
              <UpdateSize />
            </PrivateRoutes>
          }
        />

        <Route
          path="/color"
          element={
            <PrivateRoutes>
              <ColorList />
            </PrivateRoutes>
          }
        />
        <Route
          path="/addcolor"
          element={
            <PrivateRoutes>
              <AddColor />
            </PrivateRoutes>
          }
        />
        <Route
          path="/upadtecolor/:id"
          element={
            <PrivateRoutes>
              <UpdateColor />
            </PrivateRoutes>
          }
        />

        <Route
          path="/product"
          element={
            <PrivateRoutes>
              <ProductList />
            </PrivateRoutes>
          }
        />
        {/* Legacy pending route now opens the tabbed bulk-edit shell pre-set
            to the Pending tab. Keeps existing in-app navigates working without
            forcing them to know about the new shell URL. */}
        <Route
          path="/product/pending"
          element={
            <PrivateRoutes>
              <BulkParentPage initialTab="pending" />
            </PrivateRoutes>
          }
        />
        <Route
          path="/product/import-images"
          element={
            <PrivateRoutes>
              <ImportImagesPage />
            </PrivateRoutes>
          }
        />
        <Route
          path="/addproduct"
          element={
            <PrivateRoutes>
              <AddProduct />
            </PrivateRoutes>
          }
        >
          <Route index element={<Navigate to="general" replace />} />
          <Route path="general" element={<GeneralScreen />} />
          <Route path="advance" element={<AdvanceScreen />} />
          <Route path="bulk-upload" element={<ProductBulkUpload />} />
        </Route>
        <Route
          path="/updateproduct/:id"
          element={
            <PrivateRoutes>
              <UpdateProduct />
            </PrivateRoutes>
          }
        >
          <Route index element={<Navigate to="general" replace />} />
          <Route path="general" element={<GeneralScreen />} />
          <Route path="advance" element={<AdvanceScreen />} />
          <Route path="history" element={<HistoryScreen />} />
        </Route>
        <Route
          path="/occassion"
          element={
            <PrivateRoutes>
              <OccassonList />
            </PrivateRoutes>
          }
        />
        <Route
          path="/addoccassion"
          element={
            <PrivateRoutes>
              <AddOccassion />
            </PrivateRoutes>
          }
        />
        <Route
          path="/upadteoccassion/:id"
          element={
            <PrivateRoutes>
              <UpdateOccassion />
            </PrivateRoutes>
          }
        />
        <Route path="/type" element={<Navigate to="/catalog" replace />} />
        <Route path="/addtype" element={<Navigate to="/catalog" replace />} />
        <Route path="/updatetype/:id" element={<Navigate to="/catalog" replace />} />

        <Route
          path="/brand"
          element={
            <PrivateRoutes>
              <BrandList />
            </PrivateRoutes>
          }
        />
        <Route
          path="/addbrand"
          element={
            <PrivateRoutes>
              <BrandForm mode="create" />
            </PrivateRoutes>
          }
        />
        <Route
          path="/upadtebrand/:id"
          element={
            <PrivateRoutes>
              <BrandForm mode="edit" />
            </PrivateRoutes>
          }
        />
        <Route
          path="/cartlist"
          element={
            <PrivateRoutes>
              <CartList />
            </PrivateRoutes>
          }
        />

        <Route
          path="/offerlist"
          element={
            <PrivateRoutes>
              <OffersList />
            </PrivateRoutes>
          }
        />
        <Route
          path="/addoffers"
          element={
            <PrivateRoutes>
              <AddOffers />
            </PrivateRoutes>
          }
        />
        {/* <Route
          path="/viewpage/:id"
          element={
            <PrivateRoutes>
              <ViewPage />
            </PrivateRoutes>
          }
        /> */}
        <Route
          path="/updateoffers/:id"
          element={
            <PrivateRoutes>
              <UpdateOffers />
            </PrivateRoutes>
          }
        />

        <Route
          path="/banners"
          element={
            <PrivateRoutes>
              <BannersList />
            </PrivateRoutes>
          }
        />
        <Route
          path="/banners/create"
          element={
            <PrivateRoutes>
              <BannerForm />
            </PrivateRoutes>
          }
        />
        <Route
          path="/banners/edit/:id"
          element={
            <PrivateRoutes>
              <BannerForm />
            </PrivateRoutes>
          }
        />

        <Route
          path="/promo-popups"
          element={
            <PrivateRoutes>
              <PromoPopupsList />
            </PrivateRoutes>
          }
        />
        <Route
          path="/promo-popups/create"
          element={
            <PrivateRoutes>
              <PromoPopupForm />
            </PrivateRoutes>
          }
        />
        <Route
          path="/promo-popups/edit/:id"
          element={
            <PrivateRoutes>
              <PromoPopupForm />
            </PrivateRoutes>
          }
        />

        <Route
          path="/dynamic-sections"
          element={
            <PrivateRoutes>
              <DynamicSectionsList />
            </PrivateRoutes>
          }
        />
        <Route
          path="/dynamic-sections/create"
          element={
            <PrivateRoutes>
              <DynamicSectionForm />
            </PrivateRoutes>
          }
        />
        <Route
          path="/dynamic-sections/edit/:id"
          element={
            <PrivateRoutes>
              <DynamicSectionForm />
            </PrivateRoutes>
          }
        />
        <Route
          path="/trust-strip"
          element={
            <PrivateRoutes>
              <TrustStrip />
            </PrivateRoutes>
          }
        />
        <Route
          path="/homepage-arrange"
          element={
            <PrivateRoutes>
              <HomepageArrange />
            </PrivateRoutes>
          }
        />

        <Route
          path="*"
          element={
            <PrivateRoutes>
              <Page404 />
            </PrivateRoutes>
          }
        />
      </Routes>
    </div>
  );
}

export default AppRoutes;
